module.exports = __webpack_public_path__ + "img/title-@3x.a6bc406c.png";